module.exports = __webpack_public_path__ + "static/img/final-Logo.8fdc81bd.png";